import React from 'react';
import { Toaster as RadixSonner, toast } from 'sonner';
import { 
    FaCheckCircle, 
    FaExclamationTriangle, 
    FaExclamationCircle, 
    FaInfoCircle, 
    FaSpinner 
} from '../icons/faLite'; // TASK-157: fuera de react-icons/fa para no inflar main.js
import '../../styles/sonnerToast.css';

/**
 * Componente Toaster basado en Radix / Shadcn Sonner,
 * personalizado con el Design System de uTurno.
 */
const Toaster = ({ ...props }) => {
    return (
        <RadixSonner
            position="top-center"
            richColors
            closeButton
            expand={false}
            visibleToasts={4}
            duration={4000}
            icons={{
                success: <FaCheckCircle className="sonner-custom-icon sonner-icon-success" />,
                info: <FaInfoCircle className="sonner-custom-icon sonner-icon-info" />,
                warning: <FaExclamationCircle className="sonner-custom-icon sonner-icon-warning" />,
                error: <FaExclamationTriangle className="sonner-custom-icon sonner-icon-error" />,
                loading: <FaSpinner className="sonner-custom-icon sonner-icon-loading spin-animation" />
            }}
            toastOptions={{
                className: 'uturno-sonner-toast',
                classNames: {
                    toast: 'uturno-sonner-card',
                    title: 'uturno-sonner-title',
                    description: 'uturno-sonner-description',
                    actionButton: 'uturno-sonner-action-btn',
                    cancelButton: 'uturno-sonner-cancel-btn',
                    closeButton: 'uturno-sonner-close-btn',
                },
            }}
            {...props}
        />
    );
};

export { Toaster, toast };
export default Toaster;
